/**
 * Locale plumbing for the PWA — FR/EN static catalogs from @td/i18n.
 * Default: browser language; user override persisted in localStorage.
 */
import { isLocale, localeFromLanguageTag, type Locale } from "@td/i18n";

export { makeT, t, tLabel, LOCALES, loadCatalog, isCatalogLoaded, type Locale, type MessageKey } from "@td/i18n";

const LOCALE_STORAGE_KEY = "td_locale";

export function detectLocale(): Locale {
  try {
    const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
    if (stored !== null && isLocale(stored)) return stored;
  } catch {
    /* storage unavailable (private mode) — fall through to language tag */
  }
  return localeFromLanguageTag(typeof navigator !== "undefined" ? navigator.language : null);
}

export function persistLocale(locale: Locale): void {
  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  } catch {
    /* best-effort */
  }
}
